// Helpers de mapeo/formato para conectar el remastered al mismo endpoint que MensajeriaScreen

// "dd/MM/yyyy hh:mm AM/PM" -> Date. Igual al parseo usado en MensajeriaScreen.
export const parseFechaMensajeria = (fechaStr) => {
    if (!fechaStr) return null;

    const [fecha, hora, meridiano] = fechaStr.split(" ");
    const [dia, mes, anio] = fecha.split("/");

    let [horas, minutos] = hora.split(":");
    let h = parseInt(horas, 10);

    if (meridiano === "PM" && h !== 12) h += 12;
    if (meridiano === "AM" && h === 12) h = 0;

    return new Date(anio, mes - 1, dia, h, minutos);
};

const obtenerIniciales = (nombre = "") => {
    const palabras = nombre.trim().split(/\s+/).filter(Boolean);
    if (palabras.length === 0) return "--";
    if (palabras.length === 1) return palabras[0].slice(0, 2).toUpperCase();
    return (palabras[0][0] + palabras[1][0]).toUpperCase();
};

// alerta -> sin_atender (requiere respuesta nuestra, franja roja)
// sin_respuesta -> ya le respondimos y el cliente no ha contestado; de nuestro lado está atendido
// atendido -> atendido (sección apagada)
const obtenerEstado = (contacto) => (contacto.alerta ? "sin_atender" : "atendido");

// Tiempo relativo ("hace Nh"/"hace Nd") para sin_atender; fecha y hora completas (tal cual el
// API) para atendidos — igual al criterio visual del prompt original (rojo/relativo arriba,
// gris/absoluto abajo)
const formatearTiempo = (fechaStr, esSinAtender) => {
    if (!esSinAtender) return fechaStr ?? "";

    const fecha = parseFechaMensajeria(fechaStr);
    if (!fecha) return "";

    const diffMs = Date.now() - fecha.getTime();
    const horas = Math.floor(diffMs / (1000 * 60 * 60));
    if (horas < 1) return "hace unos min";
    if (horas < 24) return `hace ${horas}h`;
    const dias = Math.floor(horas / 24);
    return `hace ${dias}d`;
};

// Contacto crudo del API (ContactosMensajeriaMenu/obtenerContactos) -> shape que consume
// MensajeriaColumnaChats (id, iniciales, nombre, mensaje, tiempo, estado)
export const mapearContactoARemastered = (contacto) => {
    const estado = obtenerEstado(contacto);
    return {
        id: contacto.telefono ?? contacto.cliente,
        iniciales: obtenerIniciales(contacto.cliente),
        nombre: contacto.cliente ?? "Sin nombre",
        mensaje: contacto.mensaje ?? "",
        tiempo: formatearTiempo(contacto.ultimo_mensaje, estado === "sin_atender"),
        estado,
        telefono: contacto.telefono,
        sucursal: contacto.sucursal,
        modulo: contacto.modulo,
        fechaMensaje: parseFechaMensajeria(contacto.ultimo_mensaje),
    };
};

export const SUCURSALES_CATALOGO = {
    1: "NAVOLATO",
    2: "TEPIC",
    11: "CAIMANERO",
    12: "SAN JOSE",
    21: "ELDORADO",
    22: "SANTIAGO I.",
    31: "COSTA RICA",
    32: "TECUALA",
    41: "LA CRUZ",
    42: "LAS VARAS",
    51: "EL ROSARIO",
    52: "SAN VICENTE",
    61: "VILLA UNION",
};
